import { Button, Col, Modal, Row, Form as BForm } from '@themesberg/react-bootstrap'
import { ErrorMessage, Form, Formik } from 'formik'
import React, { useEffect, useState } from 'react'
import { getAllPortalsStart } from '../../../store/redux-slices/tenants.js'
import { bannerType } from './constants.js'
import { uploadBannerSchema } from './schema.js'

const EditUploadBanner = ({
  type,
  data,
  show,
  setShow,
  createUpdate,
  clientsFilterData,
  portalsFilterData,
  dispatch,
  SABanners,
  validation,
  setValidation
}) => {
  const [selectedClient, setSelectedClient] = useState('')
  useEffect(() => {
    if (selectedClient) {
      dispatch(getAllPortalsStart({ adminId: selectedClient }))
    }
  }, [selectedClient])

  useEffect(() => {
    data?.adminId && setSelectedClient(data?.adminId)
  }, [data?.adminId])

  return (
    <>
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{type} Banner</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Formik
            enableReinitialize
            initialValues={{
              thumbnail: null,
              adminId: data?.adminId || '',
              tenantId: data?.tenantId || '',
              url: data?.url || '',
              name: data?.name || ''
            }}
            validationSchema={uploadBannerSchema(
              {
                type,
                minRequiredWidth: validation?.minRequiredWidth,
                minRequiredHeight: validation?.minRequiredHeight,
                maxRequiredWidth: validation?.maxRequiredWidth,
                maxRequiredHeight: validation?.maxRequiredHeight
              })}
            onSubmit={(formValues) => {
              createUpdate(formValues)
              setShow(false)
            }}
          >
            {({
              values,
              errors,
              handleSubmit,
              handleBlur,
              setFieldValue,
              handleChange
            }) => (
              <Form>
                {console.log({ values }, "valuesvalues")}
                <Row className='mt-3'>

                </Row>


                <Row className='mt-3'>
                  <Col className='d-flex align-items-center'>
                    <Col>
                      <BForm.Label>Type
                        <span className='text-danger'> *</span>
                      </BForm.Label>
                    </Col>

                    <Col xs={9}>
                      <BForm.Select
                        type='select'
                        name='bannerType'
                        disabled={type === "Update" ? true : false}
                        value={values?.bannerType}
                        onChange={(e) => {
                          handleChange(e)
                          if (e.target.value.substr(e.target.value?.length - 6) === 'Banner') {
                            setValidation({
                              minRequiredWidth: 400,
                              minRequiredHeight: 400,
                              maxRequiredWidth: 600,
                              maxRequiredHeight: 600
                            })
                          } else {
                            setValidation({
                              minRequiredWidth: 1000,
                              minRequiredHeight: 400,
                              maxRequiredWidth: 1920,
                              maxRequiredHeight: 768
                            })
                          }
                        }}
                        onBlur={handleBlur}
                      >
                        <option key='' value=''>Select</option>

                        {type == "Update" ?
                          bannerType?.map(({ label, value }, i) => {
                            const selectedTenantData = SABanners?.find(item => parseInt(values?.tenantId) === item?.tenantId)
                            if (!data?.tenantId && (parseInt(values?.tenantId) === selectedTenantData?.tenantId && selectedTenantData?.bannerUrl?.[value])) {
                              return null
                            }
                            return (
                              <option key={i} value={value}>{label}</option>
                            )
                          })
                          : bannerType?.map(({ label, value }, i) => {
                            return (
                              <option key={i} value={value}>{label}</option>
                            )
                          })}
                      </BForm.Select>

                      <ErrorMessage
                        component='div'
                        name='bannerType'
                        className='text-danger'
                      />
                    </Col>
                  </Col>
                </Row>




                <Row className='mt-3'>
                  <Col className='d-flex align-items-center'>
                    <Col>
                      <BForm.Label>Banner
                        <span className='text-danger'> *</span>
                      </BForm.Label>
                    </Col>

                    <Col xs={9}>
                      <BForm.Control
                        type='file'
                        name='thumbnail'
                        disabled={!values?.bannerType}
                        onChange={(event) => setFieldValue('thumbnail', event.target.files[0])}
                        onBlur={handleBlur}
                      />

                      <ErrorMessage
                        component='div'
                        name='thumbnail'
                        className='text-danger'
                      />
                    </Col>
                  </Col>
                </Row>

                {!errors?.thumbnail &&
                  (type === 'Create'
                    ? values?.thumbnail &&
                    <Row className='text-center'>
                      <Col>
                        <img
                          alt='not found'
                          className='mt-2'
                          style={{ maxWidth: '300px', maxHeight: '300px' }}
                          src={
                            values?.thumbnail &&
                            URL.createObjectURL(values?.thumbnail)
                          }
                        />
                      </Col>
                    </Row>
                    : (
                      <Row className='text-center'>
                        <Col>
                          {/* <img
                          alt='not found'
                          className='mt-2'
                          style={{ maxWidth: '300px', maxHeight: '300px' }}
                          src={
                            values?.thumbnail
                              ? URL.createObjectURL(values?.thumbnail)
                              :`${process.env.REACT_APP_AWS_GALLERY_URL}${data?.thumbnail}` 
                          }
                        /> */}

                          <img
                            alt="not found"
                            className="mt-2"
                            style={{ maxWidth: "300px", maxHeight: "300px" }}
                            src={
                              values.thumbnail
                                ? typeof values.thumbnail === 'string'
                                  ? `${process.env.REACT_APP_S3_URL}/${values.thumbnail}`
                                  : URL.createObjectURL(values.thumbnail)
                                : ''
                            }
                          />

                        </Col>


                      </Row>))}


                <Row className='mt-3'>
                  <Col className='d-flex align-items-center'>
                    <Col>
                      <BForm.Label>Name
                        <span className='text-danger'> *</span>
                      </BForm.Label>
                    </Col>

                    <Col xs={9}>
                      <BForm.Control
                        type='text'
                        name='name'
                        placeholder='Enter Name'
                        value={values.name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />

                      <ErrorMessage
                        component='div'
                        name='name'
                        className='text-danger'
                      />
                    </Col>
                  </Col>
                </Row>


                <div className='mt-4 d-flex justify-content-between align-items-center'>
                  <Button
                    className='btn-danger'
                    onClick={() => setShow(false)}
                  >
                    Cancel
                  </Button>
                  <Button
                    className='btn-primary ml-2'
                    disabled={!values?.thumbnail}
                    onClick={handleSubmit}
                  >
                    Submit
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal >
    </>
  )
}

export default EditUploadBanner
